var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path8, _path9, _path10, _path11, _path12, _circle, _g, _circle2, _g2, _circle3, _circle4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 68,
    viewBox: "0 0 44 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 57.1753,
    rx: 16,
    ry: 10,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 57.1753,
    rx: 13,
    ry: 8,
    fill: "#FDD020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.899 45.6068C35.899 45.6068 37.2561 49.5127 38.6868 51.3331C40.1174 53.1536 41.0084 50.3274 41.0084 50.3274C41.0084 50.3274 42.1695 46.9218 41.705 42.8968C41.2406 38.8719 39.4174 33.7141 39.4174 33.7141L35.899 45.6068Z",
    fill: "url(#paint0_linear_10001_5223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.899 45.6068C35.899 45.6068 37.2561 49.5127 38.6868 51.3331C40.1174 53.1536 41.0084 50.3274 41.0084 50.3274C41.0084 50.3274 42.1695 46.9218 41.705 42.8968C41.2406 38.8719 39.4174 33.7141 39.4174 33.7141L35.899 45.6068Z",
    fill: "url(#paint1_linear_10001_5223)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07614 45.6068C9.07614 45.6068 7.71897 49.5127 6.28832 51.3331C4.85766 53.1536 3.96668 50.3274 3.96668 50.3274C3.96668 50.3274 2.80563 46.9218 3.27005 42.8968C3.73447 38.8719 5.55769 33.7141 5.55769 33.7141L9.07614 45.6068Z",
    fill: "url(#paint2_linear_10001_5223)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7325 10.9367C11.0501 8.80602 11.4938 7.92234 11.6773 6.90094L32.2571 8.65686C32.5198 9.56637 32.3712 10.6179 32.264 11.0301C31.6205 13.3206 29.4874 13.899 28.5013 13.9019L15.7571 13.7766C13.3639 13.6275 12.0493 11.7702 11.7325 10.9367Z",
    fill: "url(#paint3_linear_10001_5223)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1625 4.03872C12.3657 4.12783 11.4889 6.70734 11.5252 7.98595C11.5368 11.9651 15.4619 12.7317 17.423 12.6176L27.5335 12.5881C31.565 12.7063 32.4583 10.5906 32.401 9.51794C32.366 6.44912 29.7128 5.58127 28.3906 5.53095C27.7268 0.877493 23.9855 -0.0586958 22.1978 0.0548927C17.5164 0.0685688 16.2237 2.71647 16.1625 4.03872Z",
    fill: "url(#paint4_linear_10001_5223)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5028 13.1438C21.5028 13.1438 21.5637 12.985 21.9815 12.9715C22.3993 12.958 22.4713 13.126 22.4713 13.126L22.6677 16.7396L21.7063 16.7176L21.5028 13.1438Z",
    fill: "url(#paint5_linear_10001_5223)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97005 29.7426C8.1067 18.3394 17.4908 15.6182 21.9157 15.683C29.6396 15.373 36.7074 19.9789 38.8427 28.4742C41.2603 38.0931 38.0282 47.334 35.1306 52.1811C30.8346 59.3676 27.4908 60.5579 26.1643 60.3196C24.4134 60.0049 23.9103 56.0987 23.7708 54.7408C22.6727 55.3651 20.5104 55.1044 19.8606 54.8598L19.6032 56.2924C18.7826 60.7847 16.3389 60.2667 15.368 59.4715C4.00111 50.161 4.78091 34.5316 5.97005 29.7426Z",
    fill: "url(#paint6_linear_10001_5223)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1379,
    cy: 25.1586,
    rx: 4.51292,
    ry: 6.0739,
    transform: "rotate(10.1866 16.1379 25.1586)",
    fill: "url(#paint7_linear_10001_5223)",
    fillOpacity: 0.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.3057,
    cy: 25.6385,
    rx: 4.51292,
    ry: 6.0739,
    transform: "rotate(-9.89189 28.3057 25.6385)",
    fill: "url(#paint8_linear_10001_5223)",
    fillOpacity: 0.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1809,
    cy: 25.6221,
    rx: 3.95654,
    ry: 4.94567,
    transform: "rotate(10.1866 16.1809 25.6221)",
    fill: "url(#paint9_linear_10001_5223)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2725,
    cy: 26.0139,
    rx: 3.95654,
    ry: 4.94567,
    transform: "rotate(-7.24141 28.2725 26.0139)",
    fill: "url(#paint10_linear_10001_5223)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9441,
    cy: 25.5708,
    rx: 2.47284,
    ry: 3.46197,
    transform: "rotate(10.1866 16.9441 25.5708)",
    fill: "url(#paint11_linear_10001_5223)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9441,
    cy: 25.5708,
    rx: 2.47284,
    ry: 3.46197,
    transform: "rotate(10.1866 16.9441 25.5708)",
    fill: "url(#paint12_linear_10001_5223)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.2757,
    cy: 25.8351,
    rx: 2.47284,
    ry: 3.46197,
    transform: "rotate(-6.22363 27.2757 25.8351)",
    fill: "url(#paint13_linear_10001_5223)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5292,
    cy: 24.708,
    rx: 0.812469,
    ry: 1.13746,
    transform: "rotate(10.1866 17.5292 24.708)",
    fill: "#FBFFFF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1094,
    cy: 25.2738,
    rx: 0.812469,
    ry: 1.13746,
    transform: "rotate(-16.909 27.1094 25.2738)",
    fill: "#FBFFFF"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9567,
    cy: 31.1282,
    rx: 1.73098,
    ry: 1.06641,
    transform: "rotate(10.1866 11.9567 31.1282)",
    fill: "#F77935"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9665,
    cy: 31.6276,
    rx: 1.73098,
    ry: 1.06641,
    transform: "rotate(-0.431125 31.9665 31.6276)",
    fill: "#F77935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.277 31.7884L17.2362 32.1322C18.655 35.2259 20.9133 35.1691 21.8124 35.1336C23.5836 35.0876 25.4917 33.1375 26.277 31.7884Z",
    fill: "url(#paint14_linear_10001_5223)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6079 32.7411C24.7443 32.165 23.7821 31.9537 23.0917 31.9102L22.3683 31.9377C20.2356 32.2861 19.1854 33.2892 18.7292 34.194C19.9223 35.1934 21.1912 35.1588 21.8121 35.1343C23.1932 35.0984 24.6575 33.9047 25.6079 32.7411Z",
    fill: "#032E58"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.978 31.8406L18.3103 32.0862C19.0045 32.8111 21.1068 33.4224 22.6452 32.4077C22.7079 32.3663 22.783 32.3513 22.8472 32.3684C23.9809 32.6702 24.7685 32.1242 24.978 31.8406Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3492 20.6734L26.1543 20.1534C26.0319 20.1382 25.9561 20.0115 26.0144 19.9029C26.5573 18.8916 27.8536 18.689 28.4495 18.7797C29.6618 18.8757 30.5086 19.9963 30.5189 20.5459C30.5205 20.6331 30.4358 20.6842 30.3492 20.6734Z",
    fill: "url(#paint15_linear_10001_5223)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1528 20.3916L18.3571 19.9536C18.4798 19.9408 18.558 19.8156 18.5018 19.7058C17.9788 18.6841 16.6867 18.4563 16.0892 18.5354C14.8752 18.6077 14.0067 19.7116 13.9857 20.2609C13.9824 20.348 14.0661 20.4007 14.1528 20.3916Z",
    fill: "url(#paint16_linear_10001_5223)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0786,
    cy: 45.5659,
    r: 6.14568,
    transform: "rotate(10.1866 22.0786 45.5659)",
    fill: "#24FDF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_10001_5223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.0786,
    cy: 45.5659,
    r: 6.14568,
    transform: "rotate(10.1866 22.0786 45.5659)",
    fill: "#24FDF5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0791,
    cy: 45.5657,
    r: 5.17531,
    transform: "rotate(10.1866 22.0791 45.5657)",
    fill: "#E9FCFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10001_5223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.0791,
    cy: 45.5657,
    r: 5.17531,
    transform: "rotate(10.1866 22.0791 45.5657)",
    fill: "#E9FCFF"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.8752,
    cy: 2.8752,
    r: 2.8752,
    transform: "matrix(-0.999912 -0.0132435 -0.0132435 0.999912 24.9368 41.4253)",
    fill: "url(#paint17_angular_10001_5223)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.87521,
    cy: 2.87521,
    r: 2.87521,
    transform: "matrix(-0.999912 -0.0132436 -0.0132436 0.999912 24.8989 44.2998)",
    fill: "url(#paint18_angular_10001_5223)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3007 15.6723C17.8179 16.0501 9.65616 17.9246 6.58605 29.0596C5.8522 31.7211 5.15654 39.1493 7.0448 45.7108L6.76961 45.0529C4.71302 38.6498 5.2634 32.5895 5.97019 29.7431C8.10683 18.3399 17.4909 15.6187 21.9159 15.6835C22.0443 15.6784 22.1726 15.6746 22.3007 15.6723Z",
    fill: "url(#paint19_linear_10001_5223)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2306 57.7366C18.2014 60.6521 16.219 60.1681 15.3681 59.4711C14.596 58.8387 13.8799 58.1771 13.2162 57.4917C13.0372 57.3029 12.8664 57.1175 12.6797 56.911C12.7213 56.9434 12.7644 56.977 12.8089 57.0117C14.5837 58.3964 18.5527 61.4928 18.8115 55.1741C16.5467 54.3655 14.8134 53.4041 12.9484 50.6151C16.0857 53.8829 23.3621 56.9777 31.8683 50.1807C30.9384 51.2916 28.3481 53.7985 25.4265 54.9386C25.4097 57.6742 26.8039 61.8973 31.7312 56.911L31.0525 57.6811C28.7598 60.0206 27.0313 60.475 26.1644 60.3192C24.4134 60.0046 23.9103 56.0983 23.7709 54.7405C22.6728 55.3648 20.5105 55.104 19.8607 54.8594L19.8587 54.8705C19.8565 54.8697 19.8544 54.8689 19.8523 54.8682L19.5949 56.3008C19.4903 56.8493 19.3678 57.3253 19.2306 57.7366Z",
    fill: "url(#paint20_linear_10001_5223)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.49318 49.7653C5.02555 41.9516 5.96718 32.8094 6.97203 29.0463C6.46863 31.8479 7.11126 35.7901 7.22068 37.4165C8.70366 34.528 9.71558 39.1793 10.0362 41.866C11.3912 47.9812 15.0437 52.4058 20.8803 53.4546C18.0312 53.7642 14.6416 51.4937 13.4237 50.1429C11.3229 47.8128 8.73707 47.8767 9.49318 49.7653Z",
    fill: "#17D2B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.6032 34.5162C38.8024 27.4809 35.0812 21.5485 33.1274 20.6553C34.6339 21.9595 34.8521 23.8408 34.6566 24.2512C33.7779 30.661 35.0458 31.3608 35.7896 30.9095C37.5737 29.1309 38.4087 32.5729 38.6032 34.5162Z",
    fill: "#B3FF96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9875 35.653C19.8475 36.0183 22.1291 36.4882 24.3749 35.4458C23.4756 36.5845 21.139 38.22 18.9875 35.653Z",
    fill: "#0E67A5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2981 6.07809C11.8475 7.36644 11.546 10.3248 13.9446 11.8512C12.5823 11.4056 10.3458 9.62711 12.2981 6.07809Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0884 19.3365C14.3489 19.0088 15.0715 18.3685 15.8782 18.429C15.416 18.2105 14.411 18.0862 14.0884 19.3365Z",
    fill: "#DFFE7D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8591 19.5347C26.1196 19.207 26.8423 18.5667 27.6489 18.6272C27.1868 18.4088 26.1818 18.2844 25.8591 19.5347Z",
    fill: "#DFFE7D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7993 35.3568C21.9612 35.3932 23.2234 35.1348 24.0412 34.5815C24.0091 35.3408 23.0447 35.9258 21.7993 35.3568Z",
    fill: "#68F88D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7603 21.0254C20.2392 21.6304 21.0257 23.6521 20.3401 26.899C20.7854 25.6134 21.2929 22.6387 19.7603 21.0254Z",
    fill: "#E0FF7D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10001_5223",
    x: 10.3039,
    y: 33.7909,
    width: 23.5495,
    height: 23.5495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.814,
    result: "effect1_foregroundBlur_10001_5223"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10001_5223",
    x: 6.30893,
    y: 29.7957,
    width: 31.5403,
    height: 31.5398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.29695,
    result: "effect1_foregroundBlur_10001_5223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10001_5223",
    x1: 39.0225,
    y1: 43.0209,
    x2: 44.77,
    y2: 47.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10001_5223",
    x1: 39.0225,
    y1: 43.0209,
    x2: 44.77,
    y2: 47.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10001_5223",
    x1: 5.95255,
    y1: 43.0209,
    x2: 0.205103,
    y2: 47.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10001_5223",
    x1: 11.8333,
    y1: 10.5303,
    x2: 32.4066,
    y2: 10.5908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6CAFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10001_5223",
    x1: 29.9653,
    y1: 2.28605,
    x2: 14.1651,
    y2: 9.74426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10001_5223",
    x1: 22.2865,
    y1: 13.5447,
    x2: 22.4365,
    y2: 15.5298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2076E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10001_5223",
    x1: 21.0933,
    y1: 22.3825,
    x2: 22.4946,
    y2: 59.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88DA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227766,
    stopColor: "#2DCC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527866,
    stopColor: "#09BEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751875,
    stopColor: "#14BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0456DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10001_5223",
    x1: 16.1379,
    y1: 19.0847,
    x2: 16.1379,
    y2: 25.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BCE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10001_5223",
    x1: 28.3057,
    y1: 19.5646,
    x2: 28.3057,
    y2: 25.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#095F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BCE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10001_5223",
    x1: 16.1809,
    y1: 27.6622,
    x2: 16.1809,
    y2: 22.0983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10001_5223",
    x1: 28.2725,
    y1: 28.054,
    x2: 28.2725,
    y2: 22.4902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10001_5223",
    x1: 16.1405,
    y1: 28.4146,
    x2: 16.9441,
    y2: 22.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10001_5223",
    x1: 16.1405,
    y1: 28.4146,
    x2: 16.9441,
    y2: 22.8507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10001_5223",
    x1: 26.472,
    y1: 28.6789,
    x2: 27.2757,
    y2: 23.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49598B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10001_5223",
    x1: 21.8541,
    y1: 31.5583,
    x2: 21.9821,
    y2: 34.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12184C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0474BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10001_5223",
    x1: 26.5253,
    y1: 19.1336,
    x2: 29.0272,
    y2: 20.7235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02555E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10001_5223",
    x1: 14.6267,
    y1: 19.7204,
    x2: 17.4822,
    y2: 20.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02555E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_angular_10001_5223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.87521 2.87521) rotate(180) scale(1.81115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A5EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_10001_5223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.87521 2.87521) scale(2.87521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20FEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24FFFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10001_5223",
    x1: 20.7076,
    y1: 16.6167,
    x2: 4.7557,
    y2: 41.6845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#94FD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FE8A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10001_5223",
    x1: 20.0041,
    y1: 49.1443,
    x2: 19.5168,
    y2: 59.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003982"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSpot);
export default __webpack_public_path__ + "static/media/navigation-spot.2311ad5f5034e97b485915e118372fb4.svg";
export { ForwardRef as ReactComponent };